import editIcon from '@disy/cadenza-icons/edit.svg';

import { editSketchLayer } from 'cadenza/map/actions/add-sketch';
import { getSketchState } from 'cadenza/map/classic-sketch-layer/sketch-state';
import { icon } from 'cadenza/utils/icon/icon';
import i18n from 'cadenza/map/layer-actions/layer-actions.properties';

import { LayerAction } from './layer-action';

export class EditSketch extends LayerAction {

  #map;

  constructor (layer, options) {
    super(layer, Object.assign({
      label: i18n('mapConfig.editSketch'),
      icon: icon(editIcon)
    }, options));
    this.#map = options.map;
  }

  get disabled () {
    const {
      isEditing,
      sharedWithEditPrivilegeButNotAllowedToEditInDBRepo
    } = getSketchState(this.#map, this.layer);
    return isEditing || sharedWithEditPrivilegeButNotAllowedToEditInDBRepo;
  }

  execute () {
    editSketchLayer(this.#map, this.layer);
    return Promise.resolve();
  }

  isSupportedSync ({ isEditingLayer }) {
    const { currentSketchLayer } = getSketchState(this.#map, this.layer);
    if (isEditingLayer && this.layer !== currentSketchLayer) {
      return false;
    }

    const { canEditLayer } = getSketchState(this.#map, this.layer);
    return canEditLayer;
  }

}
